import { render } from "./WelcomeCustomer.vue?vue&type=template&id=00bc2552&scoped=true"
import script from "./WelcomeCustomer.vue?vue&type=script&lang=js"
export * from "./WelcomeCustomer.vue?vue&type=script&lang=js"

import "./WelcomeCustomer.vue?vue&type=style&index=0&id=00bc2552&scoped=true&lang=css"
import "./WelcomeCustomer.vue?vue&type=style&index=1&id=00bc2552&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00bc2552"]])

export default __exports__